export default __webpack_public_path__ + "static/media/faq_1_img_4.988bb20d.svg";